module.exports = __webpack_public_path__ + "img/bg_course_01.5b780624.png";